import React, { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TeamV2LeadsMenu from '../components/teamLeads/teamMain/TeamV2LeadsMenu';
import TeamV2LeadsTable from '../components/teamLeads/teamMain/teamLeadsTable/TeamV2LeadsTable';
import TeamV2ImportViaCSV from '../components/teamLeads/teamMain/addLeads/TeamV2ImportViaCSV';
import TeamV2LeadDetailsContainer from '../components/teamLeads/teamMain/teamLeadDetails/TeamV2LeadDetailsContainer';
import NotificationSnackbar from '../../components/common/notification/NotificationSnackbar';

const TeamV2LeadsContainer = () => {
    const navigate = useNavigate();

    // State for lead details page
    const [selectedLead, setSelectedLead] = useState(null);
    const [showLeadDetails, setShowLeadDetails] = useState(false);

    // Comprehensive hardcoded team leads data (matching individual plan structure)
    const [teamLeads, setTeamLeads] = useState([
        {
            _id: '1',
            leadName: 'John Smith',
            leadEmail: 'john.smith@company.com',
            leadJobTitle: 'Software Engineer',
            leadCompany: 'Tech Corp',
            leadPhoneNumber: '+1-555-0123',
            website: 'https://johnsmith.dev',
            linkedin: 'https://linkedin.com/in/johnsmith',
            instagram: '@johnsmith',
            location: 'San Francisco, CA',
            bio: 'Full-stack developer with 5 years experience in React and Node.js',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=1',
            createdAt: '2025-08-15T10:30:00Z',
            status: 'Active',
            role: 'Developer',
            department: 'Engineering',
            leadSource: 'csv-import',
            lastContacted: '2025-08-20T14:30:00Z',
            notes: 'Interested in our new API features',
            crmLink: 'https://crm.techcorp.com/leads/001',
            exportedTo: 'HubSpot',
            exportedToIcon: 'Hubspot',
            cardSource: 'CSV Import'
        },
        {
            _id: '2',
            leadName: 'Sarah Johnson',
            leadEmail: 'sarah.johnson@company.com',
            leadJobTitle: 'Product Manager',
            leadCompany: 'Tech Corp',
            leadPhoneNumber: '+1-555-0124',
            website: 'https://sarahjohnson.com',
            linkedin: 'https://linkedin.com/in/sarahjohnson',
            instagram: '@sarahjohnson',
            location: 'New York, NY',
            bio: 'Product strategist focused on user experience and growth',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=2',
            createdAt: '2025-08-20T14:15:00Z',
            status: 'Active',
            role: 'Manager',
            department: 'Product',
            leadSource: 'lead-capture-form',
            lastContacted: '2025-08-22T09:15:00Z',
            notes: 'Looking for team collaboration tools',
            crmLink: 'https://crm.techcorp.com/leads/002',
            exportedTo: 'Salesforce',
            exportedToIcon: 'Salesforce',
            cardSource: 'LinkedIn Import'
        },
        {
            _id: '3',
            leadName: 'Mike Chen',
            leadEmail: 'mike.chen@company.com',
            leadJobTitle: 'UI/UX Designer',
            leadCompany: 'Design Studio',
            leadPhoneNumber: '+1-555-0125',
            website: 'https://mikechen.design',
            linkedin: 'https://linkedin.com/in/mikechen',
            instagram: '@mikechen',
            location: 'Los Angeles, CA',
            bio: 'Creative designer with expertise in UX/UI and brand identity',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=3',
            createdAt: '2025-08-25T09:45:00Z',
            status: 'Active',
            role: 'Designer',
            department: 'Design',
            leadSource: 'manually-added',
            lastContacted: '2025-08-28T16:20:00Z',
            notes: 'Interested in design system collaboration',
            crmLink: 'https://crm.designstudio.com/leads/003',
            exportedTo: 'Pipedrive',
            exportedToIcon: 'Pipedrive',
            cardSource: 'Manual Entry'
        },
        {
            _id: '4',
            leadName: 'Emily Davis',
            leadEmail: 'emily.davis@company.com',
            leadJobTitle: 'Marketing Director',
            leadCompany: 'Marketing Pro',
            leadPhoneNumber: '+1-555-0126',
            website: 'https://emilydavis.com',
            linkedin: 'https://linkedin.com/in/emilydavis',
            instagram: '@emilydavis',
            location: 'Chicago, IL',
            bio: 'Digital marketing expert with 8 years of experience',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=4',
            createdAt: '2025-09-01T11:20:00Z',
            status: 'Active',
            role: 'Director',
            department: 'Marketing',
            leadSource: 'lead-capture-form',
            lastContacted: '2025-09-05T10:30:00Z',
            notes: 'Wants to discuss lead generation strategies',
            crmLink: 'https://crm.marketingpro.com/leads/004',
            exportedTo: 'HubSpot',
            exportedToIcon: 'Hubspot',
            cardSource: 'Lead Capture Form'
        },
        {
            _id: '5',
            leadName: 'David Wilson',
            leadEmail: 'david.wilson@company.com',
            leadJobTitle: 'Sales Manager',
            leadCompany: 'Sales Corp',
            leadPhoneNumber: '+1-555-0127',
            website: 'https://davidwilson.com',
            linkedin: 'https://linkedin.com/in/davidwilson',
            instagram: '@davidwilson',
            location: 'Boston, MA',
            bio: 'Sales leader with track record of exceeding targets',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=5',
            createdAt: '2025-09-03T15:45:00Z',
            status: 'Active',
            role: 'Manager',
            department: 'Sales',
            leadSource: 'manually-added',
            lastContacted: '2025-09-08T14:15:00Z',
            notes: 'Interested in CRM integration features',
            crmLink: 'https://crm.salescorp.com/leads/005',
            exportedTo: 'Salesforce',
            exportedToIcon: 'Salesforce',
            cardSource: 'Manual Entry'
        },
        {
            _id: '6',
            leadName: 'Lisa Anderson',
            leadEmail: 'lisa.anderson@company.com',
            leadJobTitle: 'HR Director',
            leadCompany: 'HR Solutions',
            leadPhoneNumber: '+1-555-0128',
            website: 'https://lisaanderson.com',
            linkedin: 'https://linkedin.com/in/lisaanderson',
            instagram: '@lisaanderson',
            location: 'Seattle, WA',
            bio: 'Human resources professional focused on talent acquisition',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=6',
            createdAt: '2025-09-05T08:30:00Z',
            status: 'Active',
            role: 'Director',
            department: 'HR',
            leadSource: 'lead-capture-form',
            lastContacted: '2025-09-10T11:45:00Z',
            notes: 'Looking for employee engagement tools',
            crmLink: 'https://crm.hrsolutions.com/leads/006',
            exportedTo: 'HubSpot',
            exportedToIcon: 'Hubspot',
            cardSource: 'LinkedIn Import'
        },
        {
            _id: '7',
            leadName: 'Robert Taylor',
            leadEmail: 'robert.taylor@company.com',
            leadJobTitle: 'CTO',
            leadCompany: 'Tech Innovations',
            leadPhoneNumber: '+1-555-0129',
            website: 'https://roberttaylor.com',
            linkedin: 'https://linkedin.com/in/roberttaylor',
            instagram: '@roberttaylor',
            location: 'Austin, TX',
            bio: 'Technology executive with 15 years of experience',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=7',
            createdAt: '2025-09-08T13:20:00Z',
            status: 'Active',
            role: 'Executive',
            department: 'Technology',
            leadSource: 'csv-import',
            lastContacted: '2025-09-12T09:30:00Z',
            notes: 'Interested in enterprise solutions',
            crmLink: 'https://crm.techinnovations.com/leads/007',
            exportedTo: 'Salesforce',
            exportedToIcon: 'Salesforce',
            cardSource: 'CSV Import'
        },
        {
            _id: '8',
            leadName: 'Maria Garcia',
            leadEmail: 'maria.garcia@company.com',
            leadJobTitle: 'Operations Manager',
            leadCompany: 'Operations Plus',
            leadPhoneNumber: '+1-555-0130',
            website: 'https://mariagarcia.com',
            linkedin: 'https://linkedin.com/in/mariagarcia',
            instagram: '@mariagarcia',
            location: 'Miami, FL',
            bio: 'Operations specialist focused on process optimization',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=8',
            createdAt: '2025-09-10T16:15:00Z',
            status: 'Active',
            role: 'Manager',
            department: 'Operations',
            leadSource: 'manually-added',
            lastContacted: '2025-09-14T10:20:00Z',
            notes: 'Wants to streamline team workflows',
            crmLink: 'https://crm.operationsplus.com/leads/008',
            exportedTo: 'Pipedrive',
            exportedToIcon: 'Pipedrive',
            cardSource: 'Manual Entry'
        },
        {
            _id: '9',
            leadName: 'Alex Thompson',
            leadEmail: 'alex.thompson@company.com',
            leadJobTitle: 'Data Scientist',
            leadCompany: 'Data Insights Inc',
            leadPhoneNumber: '+1-555-0131',
            website: 'https://alexthompson.com',
            linkedin: 'https://linkedin.com/in/alexthompson',
            instagram: '@alexthompson',
            location: 'Denver, CO',
            bio: 'Machine learning expert with focus on predictive analytics',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=9',
            createdAt: '2025-09-12T11:30:00Z',
            status: 'Active',
            role: 'Scientist',
            department: 'Data Science',
            leadSource: 'lead-capture-form',
            lastContacted: '2025-09-16T14:45:00Z',
            notes: 'Interested in AI-powered solutions',
            crmLink: 'https://crm.datainsights.com/leads/009',
            exportedTo: 'Salesforce',
            exportedToIcon: 'Salesforce',
            cardSource: 'LinkedIn Import'
        },
        {
            _id: '10',
            leadName: 'Jessica Lee',
            leadEmail: 'jessica.lee@company.com',
            leadJobTitle: 'UX Researcher',
            leadCompany: 'User Experience Co',
            leadPhoneNumber: '+1-555-0132',
            website: 'https://jessicalee.com',
            linkedin: 'https://linkedin.com/in/jessicalee',
            instagram: '@jessicalee',
            location: 'Portland, OR',
            bio: 'User experience researcher with 6 years of experience',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=10',
            createdAt: '2025-09-14T09:20:00Z',
            status: 'Active',
            role: 'Researcher',
            department: 'Design',
            leadSource: 'csv-import',
            lastContacted: '2025-09-18T10:15:00Z',
            notes: 'Looking for user testing tools',
            crmLink: 'https://crm.userexperience.com/leads/010',
            exportedTo: 'Pipedrive',
            exportedToIcon: 'Pipedrive',
            cardSource: 'CSV Import'
        },
        {
            _id: '11',
            leadName: 'Michael Rodriguez',
            leadEmail: 'michael.rodriguez@company.com',
            leadJobTitle: 'DevOps Engineer',
            leadCompany: 'Cloud Solutions',
            leadPhoneNumber: '+1-555-0133',
            website: 'https://michaelrodriguez.com',
            linkedin: 'https://linkedin.com/in/michaelrodriguez',
            instagram: '@michaelrodriguez',
            location: 'Phoenix, AZ',
            bio: 'DevOps specialist with expertise in AWS and Kubernetes',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=11',
            createdAt: '2025-09-16T13:45:00Z',
            status: 'Active',
            role: 'Engineer',
            department: 'Infrastructure',
            leadSource: 'lead-capture-form',
            lastContacted: '2025-09-20T16:30:00Z',
            notes: 'Interested in automation tools',
            // Add missing fields for detail view
            crmLink: 'https://crm.cloudsolutions.com/leads/12345',
            exportedTo: 'Salesforce',
            exportedToIcon: 'Salesforce',
            cardSource: 'LinkedIn Import'
        },
        {
            _id: '12',
            leadName: 'Amanda White',
            leadEmail: 'amanda.white@company.com',
            leadJobTitle: 'Content Manager',
            leadCompany: 'Content Creators',
            leadPhoneNumber: '+1-555-0134',
            website: 'https://amandawhite.com',
            linkedin: 'https://linkedin.com/in/amandawhite',
            instagram: '@amandawhite',
            location: 'Nashville, TN',
            bio: 'Content strategist with focus on digital marketing',
            profilePictureUrl: 'https://i.pravatar.cc/150?img=12',
            createdAt: '2025-09-18T15:20:00Z',
            status: 'Active',
            role: 'Manager',
            department: 'Marketing',
            leadSource: 'lead-capture-form',
            lastContacted: '2025-09-22T11:00:00Z',
            notes: 'Wants to discuss content management systems',
            crmLink: 'https://crm.contentcreators.com/leads/012',
            exportedTo: 'HubSpot',
            exportedToIcon: 'Hubspot',
            cardSource: 'Lead Capture Form'
        }
    ]);

    const [searchQuery, setSearchQuery] = useState('');
    const [selectedLeadIds, setSelectedLeadIds] = useState([]);
    const [dateRange, setDateRange] = useState([
        new Date('2020-01-01'), // Start from 2020 to include all hardcoded data
        new Date() // End of today
    ]);
    const [isLoading, setIsLoading] = useState(false);
    const [showImportCSV, setShowImportCSV] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    // Filter leads based on search query and date range
    const filteredLeads = teamLeads.filter(lead => {
        const matchesSearch = !searchQuery ||
            lead.leadName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            lead.leadEmail?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            lead.leadCompany?.toLowerCase().includes(searchQuery.toLowerCase());

        const leadDate = new Date(lead.createdAt);
        const matchesDateRange = leadDate >= dateRange[0] && leadDate <= dateRange[1];

        return matchesSearch && matchesDateRange;
    });

    // Debug logging
    console.log('Total team leads:', teamLeads.length);
    console.log('Filtered leads:', filteredLeads.length);
    console.log('Date range:', dateRange);
    console.log('Search query:', searchQuery);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleRefreshLeads = async () => {
        setIsLoading(true);
        try {
            // Simulate API call
            await new Promise(resolve => setTimeout(resolve, 1000));
            console.log('Refreshing team leads...');
            setSnackbar({
                open: true,
                message: 'Team leads refreshed successfully',
                severity: 'success'
            });
        } catch (error) {
            setSnackbar({
                open: true,
                message: 'Failed to refresh team leads',
                severity: 'error'
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleAddLeads = () => {
        navigate('/team-v2/add-member');
    };

    const handleExport = (format = 'csv') => {
        const selectedLeads = getSelectedLeads();
        const leadsToExport = selectedLeads.length > 0 ? selectedLeads : filteredLeads;

        console.log(`Exporting ${leadsToExport.length} team leads in ${format} format`);
        setSnackbar({
            open: true,
            message: `Exported ${leadsToExport.length} team leads successfully`,
            severity: 'success'
        });
    };

    const handleSelectLeads = (selectedIds) => {
        setSelectedLeadIds(selectedIds);
    };

    const handleDateRangeChange = (newDateRange) => {
        setDateRange(newDateRange);
    };

    const getSelectedLeads = () => {
        return teamLeads.filter(lead => selectedLeadIds.includes(lead._id));
    };

    const handleSnackbarClose = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    // Handle Import CSV
    const handleImportCSV = () => {
        setShowImportCSV(true);
    };

    const handleImportCSVClose = () => {
        setShowImportCSV(false);
    };

    // Handle notifications from CSV import
    const handleNotification = (notificationData) => {
        if (typeof notificationData === 'string') {
            setSnackbar({
                open: true,
                message: notificationData,
                severity: 'success'
            });
        } else {
            setSnackbar({
                open: true,
                message: notificationData.message,
                severity: notificationData.severity
            });
        }
    };

    // Handle lead click to show details
    const handleLeadClick = (lead) => {
        console.log('Team lead clicked:', lead);
        setSelectedLead(lead);
        setShowLeadDetails(true);
    };

    // Handle back from lead details
    const handleBackFromDetails = () => {
        setShowLeadDetails(false);
        setSelectedLead(null);
    };

    // Handle lead deletion from details page
    const handleLeadDeleteComplete = () => {
        // Remove the lead from the list
        if (selectedLead) {
            setTeamLeads(prevLeads =>
                prevLeads.filter(lead => lead._id !== selectedLead._id)
            );
        }
        handleBackFromDetails();
    };

    // Choose what to render based on the state (like individual plan)
    const renderContent = () => {
        if (showLeadDetails && selectedLead) {
            return (
                <TeamV2LeadDetailsContainer
                    lead={selectedLead}
                    onBack={handleBackFromDetails}
                    onDeleteComplete={handleLeadDeleteComplete}
                    startInEditMode={false}
                />
            );
        }

        if (showImportCSV) {
            return (
                <TeamV2ImportViaCSV
                    onBack={handleImportCSVClose}
                    onNotification={handleNotification}
                />
            );
        }

        return (
            <>
                <TeamV2LeadsMenu
                    totalLeads={filteredLeads.length}
                    onRefresh={handleRefreshLeads}
                    onAddLeads={handleAddLeads}
                    onExport={handleExport}
                    leads={filteredLeads}
                    selectedCount={selectedLeadIds.length}
                    onDateRangeChange={handleDateRangeChange}
                    searchQuery={searchQuery}
                    onSearchChange={handleSearchChange}
                    onImportCSV={handleImportCSV}
                />
                <TeamV2LeadsTable
                    leads={filteredLeads}
                    onLeadClick={handleLeadClick}
                    isLoading={isLoading}
                    onRefresh={handleRefreshLeads}
                    onSelectLeads={handleSelectLeads}
                    selectedLeadIds={selectedLeadIds}
                />
            </>
        );
    };

    return (
        <Box sx={{ width: '100%', padding: 2 }}>
            {renderContent()}

            {/* Notification Snackbar */}
            <NotificationSnackbar
                open={snackbar.open}
                message={snackbar.message}
                handleClose={handleSnackbarClose}
                severity={snackbar.severity}
            />
        </Box>
    );
};

export default TeamV2LeadsContainer;